export function usd(amount: number, decimals = 0): string {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

export function bps(value: number, decimals = 1): string {
  return `${value.toFixed(decimals)} bps`
}

export function points(basisPoints: number): string {
  return `${(basisPoints / 100).toFixed(2)} pts`
}

export function percent(share: number): string {
  return `${(share * 100).toFixed(1)}%`
}

export function shortDate(iso: string): string {
  return new Date(`${iso}T12:00:00`).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  })
}
